<label>
    <input
        type="radio"
        class="form-check-input"
        [name]="name"
        [value]="value"
        [disabled]="disabled"
        [(ngModel)]="selectedValue"
        (ngModelChange)="onChanged($event)"
    />
    {{ label }}
</label>
